import { getByAssetLead, getByDeal } from "api/post";

export const getAssetLeadPosts = (assetLeadID) => ({
  type: "POSTS_GET",
  payload: getByAssetLead(assetLeadID),
});

export const getDealPosts = (dealID) => ({
  type: "POSTS_GET",
  payload: getByDeal(dealID),
});
